import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MembershipDetailFormModule } from '@features/membership-ui/membership-detail-form/membership-detail-form.module';
import { TransferConnectV2SettingService } from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { TransferConnectV2Module } from '@features/transfer-connect-v2/transfer-connect-v2.module';
import { SharedModule } from '@rd/shared-legacy/shared.module';
import { BannerImageModule } from '@rd/shared-legacy/widgets/banner-image/banner-image.module';
import { AnzTCMembershipComponent } from '@rd/wl/anz/views/transfer-connect-v2/membership/membership.component';
import { AnzCampaignBannerTCDetailsComponent } from '../campaign-page';
import { AnzTcV2CheckoutTermsListComponent } from '../components/transfer-connect-v2/checkout-terms-list/checkout-terms-list.component';
import { AnzTcV2LoyaltyProgramsListItemDesktopComponent } from '../components/transfer-connect-v2/loyalty-programs-list-item-desktop/loyalty-programs-list-item-desktop.component';
import { AnzTcV2LoyaltyProgramsListItemMobileComponent } from '../components/transfer-connect-v2/loyalty-programs-list-item-mobile/loyalty-programs-list-item-mobile.component';
import { AnzTcV2ProgramsBannerComponent } from '../components/transfer-connect-v2/programs-banner/programs-banner.component';
import { AnzTransferConnectV2SettingService } from '../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { AnzModule } from '../shared/anz.module';
import { AnzTcV2CheckoutComponent } from '../views/transfer-connect-v2/checkout/checkout.component';

const declaredComponents: any[] = [
  AnzTcV2CheckoutTermsListComponent,
  AnzTcV2LoyaltyProgramsListItemDesktopComponent,
  AnzTcV2LoyaltyProgramsListItemMobileComponent,
  AnzTcV2ProgramsBannerComponent,
  AnzCampaignBannerTCDetailsComponent,
  AnzTCMembershipComponent,
];

const views = [AnzTcV2CheckoutComponent];

@NgModule({
  declarations: [...declaredComponents, ...views],
  imports: [
    BannerImageModule,
    CommonModule,
    RouterModule,
    SharedModule,
    MembershipDetailFormModule,
    TransferConnectV2Module,
    AnzModule,
  ],
  providers: [
    {
      provide: TransferConnectV2SettingService,
      useClass: AnzTransferConnectV2SettingService,
    },
  ],
})
export class AnzTransferConnectV2Module {}
